export default {
    name: 'mvtSelectRange',
    emits: ['update:modelValue'],
    props: {
        data: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            default: {},
            required: false,
        },
        theme: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object,
            default: () => ({
                name: '',
                mapping: {
                    min: 'min',
                    max: 'max',
                },
                defaultValue: null,
            }),
        },
        label: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            editMin: false,
        };
    },
    methods: {
        reset() {
            if (this.options.defaultValue !== null && this.options.defaultValue.length === 2) {
                var newItem = {};
                newItem[this.options.mapping.min] = this.options.defaultValue[0];
                newItem[this.options.mapping.max] = this.options.defaultValue[1];
                this._value = newItem;
            }
        },
        changeMin(value) {
            var newItem = {};
            if (value > this.maxValue) {
                newItem[this.options.mapping.max] = 0;
            } else {
                newItem[this.options.mapping.max] = this._value[this.options.mapping.max];
            }
            newItem[this.options.mapping.min] = value;
            this._value = newItem;
        },
        selectedItemName(selectedValue, targetList) {
            for (const data of targetList) {
                if (data.value === selectedValue) {
                    return data.text;
                }
            }
        },
        changeMax(value) {
            var newItem = {};
            var val = value;
            if (this.options.type === 'mvtInputCurrency') {
                var digitalCount = value.toString().length;
                switch (digitalCount) {
                    case 1:
                        val = value * Math.pow(10, 6);
                        break;
                    case 2:
                    case 3:
                    case 4:
                        val = value * Math.pow(10, 3);
                        break;
                }
            }

            let baseValue = (this.minList && this.minList[0] && this.minList[0].value) || 0;
            if (val < this.minValue && val != baseValue) {
                newItem[this.options.mapping.min] = baseValue;
            } else {
                newItem[this.options.mapping.min] = this._value[this.options.mapping.min];
            }

            newItem[this.options.mapping.max] = val;
            this._value = newItem;
        },
    },
    computed: {
        maxList() {
            let minValue = this.minValue;
            return this.data.max.filter(function (e) {
                return e.value > minValue || e.value <= 0;
            });
        },
        minList() {
            let maxValue = this.maxValue;
            return this.data.min.filter(function (e) {
                return e.value != maxValue || e.value <= 0;
            });
        },
        maxValue: {
            get() {
                return this._value[this.options.mapping.max];
            },
            set(value) {
                this.changeMax(value * 1 || 0);
            },
        },
        minValue: {
            get() {
                return this._value[this.options.mapping.min];
            },
            set(value) {
                this.changeMin(value * 1 || 0);
            },
        },
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        minChanged() {
            let min = this.minValue * 1;
            if (this.options.defaultValue && this.options.defaultValue.length === 2) {
                return min != this.options.defaultValue[0];
            }
            return !min;
        },
        maxChanged() {
            let max = this.maxValue * 1;
            if (this.options.defaultValue && this.options.defaultValue.length === 2) {
                return max != this.options.defaultValue[1];
            }
            return !max;
        },
        changed() {
            return this.minChanged || this.maxChanged;
        },
        selectedItemText() {
            if (!this.changed) {
                return this.options.name;
            }
            let min = this.minValue * 1;
            let max = this.maxValue * 1;
            let minName = this.selectedItemName(min, this.minList),
                maxName = this.selectedItemName(max, this.maxList);
            return `${minName} - ${maxName} `;
        },
    },
};
